module.exports = __webpack_public_path__ + "img/3.3ba5da53.jpg";